import { AxiosInstance } from 'axios';
import { QueryStringBuilder } from '../helpers';
import { IMetric } from '../models';

export class LogClient {

    constructor(private axiosClient: AxiosInstance) {

    }

    public get apiUrl() {
        return `/log`;
    }

    public async aggregate(organizationalPath: string, from?: Date, to?: Date): Promise<ILogAggregationCollection> {

        const url = new QueryStringBuilder()
            .build(`${this.apiUrl}/aggregate`);

        const response = await this.axiosClient.post(
            url,
            {
                organizationalPath,
                from,
                to
            },
            {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
            }
        );

        return {
            header: organizationalPath,
            collection: response.data
        };
    }
}

export interface ILogAggregationCollection {

    header: string;

    collection: IMetric[];
}
